export const TEMPLATE_PARAM_KEYS = {
  createMode: 'createMode',
  filters: 'filters',
  search: 'search',
  templateType: 'templateType',
};
